import router from './router'
import store from './store'
import { Message, MessageBox } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken, setToken } from '@/utils/auth' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress Configuration

// permission judge function
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

const whiteList = ['/loginPage','/is_wechat_open','/universal','/new_page_warning_evaluation']// no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (getToken()) { // determine if there has token
    /* has token*/
    if (!store.getters.userName) { // 判断当前用户是否已拉取完user_info信息
      store.dispatch('GetUserInfo').then(res => { // 拉取user_info
        if (to.name === 'dashboard' && store.getters.trial_version === 1) {
          MessageBox.alert('您已获得体验版使用权限，是否跳转至体验版？', '系统提示',{
            confirmButtonText:'前往体验版',
            cancelButtonText: '进入当前版本',
            type: 'warning',
            showCancelButton:true,
            dangerouslyUseHTMLString: true,
            showConfirmButton: true,
            lockScroll:true,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            beforeClose: (action, instance, done) => {
              if (action === 'confirm') {
                window.location.replace('https://shjz.mzt.xinjiang.gov.cn/mzjz-admin-test/new/#/workspace')
              } else {
                done()
              }
            }
          });
        }
        if (store.getters.trial_version === 2 && (to.name !== 'NewPageWarningEvaluation' && to.name !== 'reportViewingTest' && to.name !== 'VerifyTest' && to.name !== 'applyHdList')){
          window.location.replace('https://shjz.mzt.xinjiang.gov.cn/mzjz-admin-test/new/#/workspace')
        }
        next({ ...to, replace: true })
        /* if (!response.data.success) {
            Message.error(response.data.remark)
          }
		      */
        /*
		      const roles = res.data.data.type // note: roles must be a array! such as: ['editor','develop']
          store.dispatch('GenerateRoutes', { roles }).then
          (() => { // 根据roles权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          })
          */
      }).catch((err) => {
        store.dispatch('FedLogOut').then(() => {
          Message.error(err.remark || '请重新登录')
          // next({ path: '/' })
          if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
            next()
          } else {
            // next('/loginPage') // 否则全部重定向到登录页
            window.location.href='https://mzggfw.mzt.xinjiang.gov.cn/osp-portal/template/login.html?service=https://shjz.mzt.xinjiang.gov.cn/mzjz-py-external-plugin/cas_security/check'
            NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
          }
        })
      })
      // next({ ...to, replace: true })
    } else {
      if (to.name === 'dashboard' && store.getters.trial_version === 1) {
        MessageBox.alert('您已获得体验版使用权限，是否跳转至体验版？', '系统提示',{
          confirmButtonText:'前往体验版',
          cancelButtonText: '进入当前版本',
          type: 'warning',
          showCancelButton:true,
          dangerouslyUseHTMLString: true,
          showConfirmButton: true,
          lockScroll:true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          beforeClose: (action, instance, done) => {
            console.log(done)
            if (action === 'confirm') {
              window.location.replace('https://shjz.mzt.xinjiang.gov.cn/mzjz-admin-test/new/#/workspace')
            } else {
              done()
            }
          }
        });
      }
      if (store.getters.trial_version === 2 && (to.name !== 'NewPageWarningEvaluation' && to.name !== 'reportViewingTest' && to.name !== 'VerifyTest' && to.name !== 'applyHdList')){
        window.location.replace('https://shjz.mzt.xinjiang.gov.cn/mzjz-admin-test/new/#/workspace')
      }
      // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
      // if (hasPermission(store.getters.roles, to.meta.roles)) {
      //   next()//
      // } else {
      //   next({ path: '/401', replace: true, query: { noGoBack: true }})
      // }
      // 可删 ↑
      next()
    }
  } else {
    let params = new URLSearchParams(window.location.href.split('?')[1])
    /* has no token*/
    if(!params.get("my_token")) {
      if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
        next()
      } else {
        // next('/loginPage') // 否则全部重定向到登录页
        window.location.href = 'https://mzggfw.mzt.xinjiang.gov.cn/osp-portal/template/login.html?service=https://shjz.mzt.xinjiang.gov.cn/mzjz-py-external-plugin/cas_security/check'
        NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
      }
    } else {
      setToken(params.get("my_token"))
      store.dispatch('GetUserInfo').then(res => { // 拉取user_info
        next({ ...to, replace: true })
        /* if (!response.data.success) {
            Message.error(response.data.remark)
          }
          */
        /*
          const roles = res.data.data.type // note: roles must be a array! such as: ['editor','develop']
          store.dispatch('GenerateRoutes', { roles }).then
          (() => { // 根据roles权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          })
          */
      }).catch((err) => {
        store.dispatch('FedLogOut').then(() => {
          Message.error(err.remark || '请重新登录')
          if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
            next()
          } else {
            // next('/loginPage') // 否则全部重定向到登录页
            window.location.href='http://atrust.flzx3qc.cn:9005/osp-portal/template/login.html?service=https://shjz.mzt.xinjiang.gov.cn/mzjz-py-external-plugin/cas_security/check'
            NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
          }
        })
      })
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js